import 'slick-carousel';

require('./store-listing');
require('./store-item');
require('./store-cart');
require('./store-shipping');

jQuery(($) => {
  $('[data-toggle="popover"]').popover();
});
